import { render, staticRenderFns } from "./BrandMediaListItem.vue?vue&type=template&id=3d184adb&scoped=true&"
import script from "./BrandMediaListItem.vue?vue&type=script&lang=js&"
export * from "./BrandMediaListItem.vue?vue&type=script&lang=js&"
import style0 from "./BrandMediaListItem.vue?vue&type=style&index=0&id=3d184adb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d184adb",
  null
  
)

export default component.exports